import { useEffect, useState } from "react";
import { IS_LOBBIE_LOCAL } from "src/constants";

const STYLE = {
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    margin: "0 auto",
} as const;

const RenderErrorHandler = () => {
    // reloading after a minute to give the developer a chance to see the error
    const [seconds, setSeconds] = useState<number>(IS_LOBBIE_LOCAL ? 60 : 10);

    useEffect(() => {
        if (seconds === 0) {
            if (window.location.pathname === "/") {
                window.location.reload();
            } else {
                window.location.href = "/";
            }
        } else {
            setTimeout(() => {
                setSeconds(seconds - 1);
            }, 1000);
        }
    }, [seconds]);

    return (
        <div style={STYLE}>
            <div>Lobbie had an issue loading the page.</div>
            <div className="mt-2">Resetting and reloading Lobbie in {seconds} seconds.</div>
            {/* <hr />
            <div className="mt-2">
                If this issue persists after Lobbie is reloaded please contact Lobbie at{" "}
                <a href="mailto:support@lobbie.com" className="blue no-underline">
                    support@lobbie.com
                </a>
                .
            </div> */}
        </div>
    );
};

export default RenderErrorHandler;
